import React from 'react';
import { Helmet } from 'react-helmet';

const SiteNavigationSchema = () => {
  // This object defines your site's navigation structure
  const navigationData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "SiteNavigationElement",
        "position": 1,
        "name": "Home",
        "description": "Secure AI for your desktop: local-first chats and files, your API keys, optional TensorPilot Pro encrypted cloud backup. BYOK multi-provider AI with enterprise-grade privacy and transparency",
        "url": "https://www.tensorpilot.io/"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 2,
        "name": "Download",
        "description": "Download TensorPilot for your device",
        "url": "https://www.tensorpilot.io/download"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 3,
        "name": "Models",
        "description": "Browse supported AI models and providers available in TensorPilot",
        "url": "https://www.tensorpilot.io/ai-models"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 4,
        "name": "Why TensorPilot",
        "description": "How TensorPilot saves you money on AI while keeping your data private and under your control",
        "url": "https://www.tensorpilot.io/why-tensorpilot"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 5,
        "name": "Blog",
        "description": "AI and machine learning articles and updates",
        "url": "https://www.tensorpilot.io/blog"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 6,
        "name": "Pricing",
        "description": "Plans and pricing for TensorPilot",
        "url": "https://www.tensorpilot.io/sales"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 7,
        "name": "Careers",
        "description": "Join TensorPilot and help democratize AI technology",
        "url": "https://www.tensorpilot.io/careers"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 8,
        "name": "Contact",
        "description": "Get in touch with the TensorPilot team",
        "url": "https://www.tensorpilot.io/contactus"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 9,
        "name": "Sign Up",
        "description": "Create a TensorPilot account",
        "url": "https://www.tensorpilot.io/signup"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 10,
        "name": "Login",
        "description": "Access your TensorPilot account",
        "url": "https://www.tensorpilot.io/login"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 11,
        "name": "Profile",
        "description": "Manage your TensorPilot profile and subscription",
        "url": "https://www.tensorpilot.io/profile"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 12,
        "name": "Search",
        "description": "Search TensorPilot's articles and content",
        "url": "https://www.tensorpilot.io/search"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 13,
        "name": "Terms & Conditions",
        "description": "Terms and conditions for using TensorPilot",
        "url": "https://www.tensorpilot.io/terms-and-conditions"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 14,
        "name": "Privacy Policy",
        "description": "Privacy policy for TensorPilot users",
        "url": "https://www.tensorpilot.io/privacy-policy"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 15,
        "name": "Forgot Password",
        "description": "Reset your TensorPilot account password",
        "url": "https://www.tensorpilot.io/forgot-password"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(navigationData)}
      </script>
    </Helmet>
  );
};

export default SiteNavigationSchema;
